import React, {useContext} from 'react';
import Login from './Login';

export default function LoginPage() {
    return (
            <Login/>
    );
}
